/**
 * Monta la pantalla de acceso de la aplicación.
 *
 * @packageDocumentation
 */

import { createApp, h } from 'vue';
import Login from '@/pages/acceso/login.vue';

document.addEventListener('DOMContentLoaded', () => {
    const el = document.getElementById('vue-app');
    if (el) {
        const app = createApp({
            /**
             * Renderiza la pantalla de acceso.
             *
             * @returns Nodo virtual del formulario de inicio de sesión.
             */
            render: () => h(Login)
        });

        app.mount(el);
    }
});
